export const GET_PAGE_CONTENTS_QUERY_KEY = (
  lookupCode: string,
  coverageId?: number,
  orgInfoBenId?: number
) => ['page-content', lookupCode, coverageId, orgInfoBenId] as const;
